/**
 * Name: Delete Songs saga
 * Author: @Gaurav
 * Date: 21-07-2021
 */
import { put, takeLatest, call } from 'redux-saga/effects';
import { fetcherDelete } from '../../utils/axios';

const callAPI = (payload) => {
  return fetcherDelete(['/songs', { data: payload }]);
};

export default function* watchRequest() {
  yield takeLatest('DELETE_SONGS', function* performAction(action) {
    yield put({ type: 'DELETE_SONGS_INITIATED' });
    try {
      const data = yield call(callAPI.bind(this, action.payload));
      yield put({ type: 'DELETE_SONGS_SUCCESS', payload: data });
    } catch (error) {
      yield put({ type: 'DELETE_SONGS_FAILED', payload: error });
    }
  });
}
